import { SignIn } from "@clerk/react";
import { AuthLayout } from "@/components/auth/AuthLayout";

export default function SignInPage() {
  return (
    <AuthLayout testId="sign-in-page">
      <SignIn routing="path" path="/sign-in" signUpUrl="/sign-up" withSignUp />
    </AuthLayout>
  );
}
